export default Object.freeze({
    Active: "Active",
    Inactive: "Inactive"
});